import { render, staticRenderFns } from "./edge_buttons.vue?vue&type=template&id=5f3c94aa&"
import script from "./edge_buttons.vue?vue&type=script&lang=js&"
export * from "./edge_buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports